import React from "react";
import { observer } from "mobx-react";

import { duration } from "@formant/core/model/duration";

import { appStore, observeStore } from "../../../stores";
import { BaseListModule } from "../BaseListModule";
import { IMetadataDataPoint } from "../utils/IMetadataDataPoint";
import { FileModuleListItem } from "./FileModuleListItem";

@observer
export class FileModule extends BaseListModule<"file"> {
    protected type: "file" = "file";

    protected listItem = (point: IMetadataDataPoint<"file">, i: number) => {
        const { hideDevice, onSelectTime } = this.props;
        const { mode, time } = observeStore;
        return (
            <FileModuleListItem
                key={i}
                point={point}
                old={
                    point.time.getTime() < time.getTime() - 5 * duration.second
                }
                live={mode === "live"}
                hideDevice={hideDevice}
                utc={appStore.utc}
                onClick={onSelectTime}
            />
        );
    };
}
